import mitt from 'mitt';

export enum EventsName {
  PAYMENT_METHOD_CHANGED = 'payment_method_changed',
  ADD_ITEM_TO_CART = 'add_to_cart',
  RESET_FILTERS = 'reset_filters',
  APPLY_FILTERS = 'apply_filters',
  MODAL_CLOSE = 'modal_close',
}

type Events = {
  [EventsName.PAYMENT_METHOD_CHANGED]: undefined;
  [EventsName.ADD_ITEM_TO_CART]: { type: 'add' | 'remove'; count: number };
  [EventsName.APPLY_FILTERS]: undefined;
  [EventsName.RESET_FILTERS]: undefined;
  [EventsName.MODAL_CLOSE]: undefined;
};

const eventEmitter = mitt<Events>();

export default eventEmitter;
